module.exports = __webpack_public_path__ + "img/wz-10-1.23be5e81.png";